import {motion} from 'framer-motion';
import {useDispatch} from 'react-redux';
import {closeModal} from '../../../../store/actions/modalActions';
import {getUsers} from '../../../../store/actions/userActions';
import styles from '../ModalStatus/ModalStatus.module.scss';
import Button from '../../../elements/Button/Button';
import {disableUser as disableUserAPI, enableUser as enableUserAPI} from "../../../../services/user";
import * as ACTIONS from "../../../../store/actions/userActions";
import toast from "react-hot-toast";
import {setErrors} from "../../../../store/actions/errorsActions";

const ModalStatusUser = ({variants, data}) => {
    const dispatch = useDispatch();
    const {id, email, isDisabled} = data;

    const handleToggleStatus = () => {
        isDisabled ? enableUser(id) : handleDisableUser(id);
        dispatch(closeModal());
    };

    const enableUser = async (id) => {
        try {
            const response = await enableUserAPI(id);
            dispatch(ACTIONS.enableUser(response.data));
            toast.success("User enabled successfully.");
            dispatch(getUsers());
        } catch (error) {
            console.error("Error enabling user:", error);
            dispatch(setErrors('user', error, "Failed to enable user."));
            toast.error("Failed to enable user.");
        }
    }

    const handleDisableUser = async (id) => {
        try {
            const response = await disableUserAPI(id);
            dispatch(ACTIONS.disableUser(response.data));
            toast.success("User disabled successfully.");
            dispatch(getUsers());
        } catch (error) {
            console.error("Error disabling user:", error);
            dispatch(setErrors('user', error, "Failed to disable user."));
            toast.error("Failed to disable user.");
        }
    };

    return (
        <motion.div className={styles.container} variants={variants}>
            <h2>Confirm Status Change</h2>
            <p className={styles.modalText}>
                Are you sure you want to {isDisabled ? 'enable' : 'disable'} the user with email: {email}?
            </p>
            <div className={styles.ctaGroup}>
                <Button type="button" className="tertiary" onClick={() => dispatch(closeModal())}>
                    Cancel
                </Button>
                <Button type="button"  className={isDisabled ? 'primary' : 'delete'} onClick={handleToggleStatus}>
                    {isDisabled ? 'Enable' : 'Disable'}
                </Button>
            </div>
        </motion.div>
    );
};

export default ModalStatusUser;
